import { WorkflowForm } from "../../../components/workflow/WorkflowForm";

const AddWorkflow = () => {
  return <WorkflowForm />;
};

export default AddWorkflow;